<template>
  <div>
    <!--  版本信息确认  -->
    <release-review-version-confirm @getVersionData="getVersionData"/>
    <el-divider></el-divider>
    <div>
      <releaseReviewItem preset="心尖四腔" mode="B模式" @getReviewData="getAFCB"/>
      <releaseReviewItem preset="心尖四腔" mode="C模式" @getReviewData="getAFCC"/>
      <releaseReviewItem preset="胸骨旁左室长轴" mode="B模式" @getReviewData="getPIVLB"/>
      <releaseReviewItem preset="胸骨旁左室长轴" mode="C模式" @getReviewData="getPIVLC"/>
      <releaseReviewItem preset="胸骨旁左室长轴" mode="M模式" @getReviewData="getPIVLM"/>
      <releaseReviewItem preset="胸骨旁左室长轴" mode="PW模式" @getReviewData="getPIVLPW"/>
      <releaseReviewItem preset="胸骨旁左室短轴" mode="B模式" @getReviewData="getPIVSB"/>
      <releaseReviewItem preset="胸骨旁左室短轴" mode="C模式" @getReviewData="getPIVSC"/>
      <releaseReviewItem preset="胸骨旁左室短轴" mode="M模式" @getReviewData="getPIVSM"/>
      <releaseReviewItem preset="胸骨旁左室短轴" mode="PW模式" @getReviewData="getPIVSPW"/>
      <releaseReviewItem preset="其他" mode="" @getReviewData="getOther"/>
    </div>
  </div>
</template>

<script>
import ReleaseReviewItem from "./ReleaseReviewItem";
import ReleaseReviewVersionConfirm from "./ReleaseReviewVersionConfirm";

export default {
  name: "ReleaseReviewForPhased",
  components: {
    ReleaseReviewItem,
    ReleaseReviewVersionConfirm
  },
  data() {
    return {
      phased: {
        afc_b_opinion: '',
        afc_b_images: [],
        afc_c_opinion: '',
        afc_c_images: [],
        piv_b_long_opinion: '',
        piv_b_long_images: [],
        piv_c_long_opinion: '',
        piv_c_long_images: [],
        piv_m_long_opinion: '',
        piv_m_long_images: [],
        piv_pw_long_opinion: '',
        piv_pw_long_images: [],
        piv_b_short_opinion: '',
        piv_b_short_images: [],
        piv_c_short_opinion: '',
        piv_c_short_images: [],
        piv_m_short_opinion: '',
        piv_m_short_images: [],
        piv_pw_short_opinion: '',
        piv_pw_short_images: [],
        version_confirm: '',
        other_opinion: '',
        other_images: []
      }
    }
  },
  watch: {
    phased: {
      handler: function (val){
        this.sendPhasedData(val);
      },
      deep: true
    }
  },
  methods: {
    // 发送最新凸阵数据给父路由
    sendPhasedData(data) {
      this.$emit('getPhasedData', this.phased);
    },
    // 得到心尖四腔B模式的调用
    getAFCB(data) {
      this.phased.afc_b_opinion = data.opinion;
      this.phased.afc_b_images = data.fileList;
    },
    // 得到心尖四腔C模式的反馈调用
    getAFCC(data) {
      this.phased.afc_c_opinion = data.opinion;
      this.phased.afc_c_images = data.fileList;
    },
    // 得到胸骨旁左室长轴B模式的反馈调用
    getPIVLB(data) {
      this.phased.piv_b_long_opinion = data.opinion;
      this.phased.piv_b_long_images = data.fileList;
    },
    // 得到胸骨旁左室长轴C模式的反馈调用
    getPIVLC(data) {
      this.phased.piv_c_long_opinion = data.opinion;
      this.phased.piv_c_long_images = data.fileList;
    },
    // 得到胸骨盘左室长轴M模式的反馈调用
    getPIVLM(data) {
      this.phased.piv_m_long_opinion = data.opinion;
      this.phased.piv_m_long_images = data.fileList;
    },
    // 得到胸骨旁左室长轴PW模式的反馈调用
    getPIVLPW(data) {
      this.phased.piv_pw_long_opinion = data.opinion;
      this.phased.piv_pw_long_images = data.fileList;
    },
    // 得到胸骨旁左室短轴B的反馈调用
    getPIVSB(data) {
      this.phased.piv_b_short_opinion = data.opinion;
      this.phased.piv_b_short_images = data.fileList;
    },
    // 得到胸骨旁左室短轴C的反馈调用
    getPIVSC(data) {
      this.phased.piv_c_short_opinion = data.opinion;
      this.phased.piv_c_short_images = data.fileList;
    },
    // 得到胸骨旁左室短轴M的反馈调用
    getPIVSM(data) {
      this.phased.piv_m_short_opinion = data.opinion;
      this.phased.piv_m_short_images = data.fileList;
    },
    // 得到胸骨旁左室短轴PW的反馈调用
    getPIVSPW(data) {
      this.phased.piv_pw_short_opinion = data.opinion;
      this.phased.piv_pw_short_images = data.fileList;
    },
    // 得到其他反馈调用
    getOther(data) {
      this.phased.other_opinion = data.opinion;
      this.phased.other_images = data.fileList;
    },
    // 得到用户的信息
    getInfoData(data) {
      this.formInline.name = data.name;
      this.formInline.phone = data.phone;
      this.formInline.probeSn = data.probeSn;
      this.formInline.probeType = data.probeType;
    },
    // 得到测试版本信息
    getVersionData(data) {
      this.phased.version_confirm = data;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/release_review/ReleaseReviewForPhased.vue